import { render, staticRenderFns } from "./StudipSelect.vue?vue&type=template&id=87b52c1c&"
import script from "./StudipSelect.vue?vue&type=script&lang=js&"
export * from "./StudipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports